import { render } from "./WholeImage.vue?vue&type=template&id=363a8374&bindings={\"panzoom\":\"data\",\"onClickOutside\":\"options\"}"
import script from "./WholeImage.vue?vue&type=script&lang=js"
export * from "./WholeImage.vue?vue&type=script&lang=js"

import "./WholeImage.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script